import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfUse = () => {
  const navigate = useNavigate();
  return (
    <div style={pageStyle}>
      <header style={headerStyle}>
        <h1 style={{ fontSize: '2.2rem', color: '#2563eb', fontWeight: 'bold' }}>תנאי שימוש - דרייבר.ישראל</h1>
        <p style={{ color: '#666' }}>פלטפורמה לחיבור בין שולחים לשליחים</p>
        <button onClick={() => navigate('/')} style={backButtonStyle}>➜ חזרה לדף הבית</button>
      </header>

      <main style={contentStyle}>
        <section>
          <h3>🚚 מהות השירות</h3>
          <p>
            דרייבר.ישראל היא פלטפורמה טכנולוגית המחברת בין אנשים המעוניינים לשלוח חבילות (״שולחים״)
            לבין אנשים המעוניינים לבצע משלוחים (״שליחים״). הפלטפורמה משמשת כלוח מודעות בלבד ואינה צד
            להתקשרות בין השולח לשליח.
          </p>
        </section>

        <section>
          <h3>1. אחריות וביצוע המשלוח</h3>
          <p>
            השולח והשליח אחראים באופן מלא ובלעדי על ההתקשרות ביניהם, על תוכן החבילה ועל ביצוע המשלוח.
            דרייבר.ישראל אינה אחראית לאובדן, נזק, איחור או כל פגם בשירות. השולח מתחייב שלא לשלוח חומרים
            מסוכנים, אסורים על פי חוק, או פריטים בלתי חוקיים.
          </p>
        </section>

        <section>
          <h3>2. תשלום בין הצדדים</h3>
          <p>
            דמי המשלוח משולמים ישירות מהשולח לשליח (במזומן), והפלטפורמה אינה צד לעסקה הכספית ואינה
            מתווכת תשלומים. המחיר המוצג באפליקציה הוא הערכה בלבד המבוססת על מרחק וגודל החבילה.
            כל שליח אחראי לדווח על הכנסותיו לרשויות המס כנדרש בחוק.
          </p>
        </section>

        <section>
          <h3>3. ציות לחוק</h3>
          <p>
            כל שימוש בפלטפורמה חייב לעמוד בחוקי מדינת ישראל, לרבות דיני התעבורה והביטוח החלים על השליח.
            השליח מצהיר כי ברשותו רישיון נהיגה בתוקף וביטוח מתאים לכלי הרכב בו הוא משתמש. אנו שומרים
            את הזכות לחסום משתמשים הפועלים בניגוד לחוק או לרוח הפלטפורמה.
          </p>
        </section>

        <section>
          <h3>4. הגבלת אחריות טכנית</h3>
          <p>
            השירות ניתן ״כמות שהוא״ (As-Is). איננו מתחייבים שהשירות יהיה זמין בכל עת או חסין מתקלות.
          </p>
        </section>
      </main>
    </div>
  );
};

const pageStyle = { fontFamily: "'Varela Round', sans-serif", direction: 'rtl', padding: '20px', backgroundColor: '#f4f7f6', minHeight: '100vh' };
const headerStyle = { textAlign: 'center', marginBottom: '30px', padding: '20px' };
const contentStyle = { maxWidth: '850px', margin: '0 auto', backgroundColor: '#fff', padding: '40px', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', lineHeight: '1.8', color: '#444' };
const backButtonStyle = { marginTop: '20px', padding: '12px 25px', border: 'none', borderRadius: '50px', backgroundColor: '#2563eb', color: 'white', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 15px rgba(37,99,235,0.3)' };

export default TermsOfUse;
